var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import MenuReturn from '../../components/console-common/menu-return.vue';
import IndicatorOverview from '../../components/ins-claim/claim-indicators.vue';
import GraphLine from '../../components/ins-claim/graph-line.vue';
import GraphBar from '../../components/ins-claim/graph-bar.vue';
import ClaimTable from '../../components/ins-claim/claim-table.vue';
import { transBarOptions, transChartLineData, formDefaultSearchDate, formatRMB, } from './trans-data-util';
import { chartLine } from './chart-config';
import { exportData } from './export-file';
import * as CLAIM_API from './claim-api';
import * as TIPS from './const-tips';
var scalePayRatio = [
    {
        dataKey: 'category',
        alias: '分类',
    },
    {
        dataKey: 'value',
        alias: '赔付率',
        formatter: function (value) { return value; },
    },
];
export default Vue.extend({
    props: {
        searchParam: {
            type: Object,
            default: null,
        },
    },
    components: {
        'el-menu-return': MenuReturn,
        'el-indicator-overview': IndicatorOverview,
        'chart-line': GraphLine,
        'chart-bar': GraphBar,
        'claim-table': ClaimTable,
    },
    computed: __assign({}, mapState('vinsurance', ['rentCompanyList', 'insCompanyList'])),
    data: function () {
        return {
            searchDefaultParam: {},
            localParams: {},
            titleConfig: {
                backTitle: '返回数据看板',
                currentTitle: '满期赔付率',
                routerName: true,
                name: 'claimBoard',
            },
            indicators: [
                {
                    span: 4,
                    label: '总赔款金额',
                    value: '--',
                    type: 'line',
                    custFont: false,
                    tips: TIPS.TipHomeExpiredTotalClaim,
                    color: '#876AD6',
                },
                {
                    span: 4,
                    label: '满期赔付率',
                    value: '--%',
                    type: 'progress',
                    custFont: false,
                    tips: TIPS.TipHomeExpiredRate,
                },
            ],
            //赔付趋势
            payExpiredTop: '',
            payExpiredLow: '',
            payExpiredAver: '',
            payExpiredOptions: __assign({}, chartLine),
            tipsGraph: TIPS.TipSubExpiredTrend,
            tableConfig: [
                {
                    label: '日期',
                    prop: 'date',
                    width: '260px',
                    formatter: function (val) {
                        return moment(val).format('YYYY-MM-DD');
                    },
                },
                {
                    label: '满期赔付率',
                    prop: 'expirePayoutRatio',
                },
            ],
            //赔付Rank
            activeRankTab: '',
            tipsRank: TIPS.TipsSubExpiredRank,
            rankTabs: [
                {
                    label: '保司',
                    name: 'insCompany',
                },
                {
                    label: '地区',
                    name: 'cityArea',
                },
            ],
            payExpiredData: null,
            chartBarOptions: null,
        };
    },
    methods: {
        formParams: function () {
            return this.localParams;
        },
        setParams: function (params) {
            this.localParams = params;
        },
        setupParams: function () {
            if (!this.insCompanyList || this.insCompanyList.length === 0) {
                this.$store.dispatch('vinsurance/GET_INS_COMPANYS'); // 获取保险公司选项
            }
            if (!this.rentCompanyList || this.rentCompanyList.length === 0) {
                this.$store.dispatch('vinsurance/GET_RENT_COMPANYS'); // 获取租赁公司选项
            }
            if (!this.searchParam) {
                this.setParams(formDefaultSearchDate());
            }
        },
        initIndicatorDefault: function () {
            this.searchDefaultParam = this.formParams();
        },
        handleSearch: function (params) {
            this.setParams(params);
            this.onFreshPage();
        },
        // 刷新整个页面
        onFreshPage: function () {
            var params = this.formParams();
            var ovParams = __assign({}, params, { overviewType: CLAIM_API.OVER_VIEW_EXPIRED });
            this.loadOverview(ovParams);
            this.loadInsExpiredTrend(params);
            this.searchTrendTable(1);
            this.queryExpiredRank(params);
        },
        // 保司/地区 Tab
        handleRankTab: function (tab, event) {
            this.activeRankTab = tab.name;
            this.showCurrentBar();
        },
        showCurrentBar: function () {
            if (this.activeRankTab === this.rankTabs[0].name) {
                var insData_1 = [];
                this.payExpiredData.insCompanyDimensionList.sort(function (a, b) {
                    return a.expirePayoutRatio > b.expirePayoutRatio
                        ? -1
                        : a.expirePayoutRatio < b.expirePayoutRatio
                            ? 1
                            : 0;
                });
                this.payExpiredData.insCompanyDimensionList
                    .slice(0, 10)
                    .forEach(function (item, index) {
                    insData_1.push({
                        category: item.insCompanyName || item.insCompanyCode,
                        value: Number(Number(item.expirePayoutRatio).toFixed(2)),
                    });
                });
                this.chartBarOptions = transBarOptions(insData_1, scalePayRatio);
            }
            else {
                var areaData_1 = [];
                this.payExpiredData.areaDimensionList.sort(function (a, b) {
                    return a.expirePayoutRatio > b.expirePayoutRatio
                        ? -1
                        : a.expirePayoutRatio < b.expirePayoutRatio
                            ? 1
                            : 0;
                });
                this.payExpiredData.areaDimensionList.slice(0, 10).forEach(function (item) {
                    areaData_1.push({
                        category: item.inscityName,
                        value: Number(Number(item.expirePayoutRatio).toFixed(2)),
                    });
                });
                this.chartBarOptions = transBarOptions(areaData_1, scalePayRatio);
            }
        },
        loadOverview: function (params) {
            var _this = this;
            CLAIM_API.queryClaimOverview(params).then(function (res) {
                if (!res || !res.data || !res.data.expireOverview)
                    return;
                if (res.errorCode)
                    return;
                var _a = res.data.expireOverview, totalPayAmount = _a.totalPayAmount, expirePayRate = _a.expirePayRate;
                _this.indicators[0].value = formatRMB(totalPayAmount);
                _this.indicators[1].value = expirePayRate.toString() + '%';
            });
        },
        loadInsExpiredTrend: function (params) {
            var _this = this;
            CLAIM_API.queryExpiredTrend(params).then(function (res) {
                if (!res || !res.data || !res.data.expireTrendList)
                    return;
                if (res.errorCode)
                    return;
                _this.payExpiredTop = res.data.maxExpirePayoutRatio.toString() + '%';
                _this.payExpiredLow = res.data.minExpirePayoutRatio.toString() + '%';
                _this.payExpiredAver = res.data.avgExpirePayoutRatio.toString() + '%';
                var rawData = res.data.expireTrendList;
                var ds = rawData.map(function (item) {
                    item.expirePayoutRatio = Number(Number(item.expirePayoutRatio).toFixed(2));
                    return item;
                });
                _this.payExpiredOptions.data = transChartLineData(ds, 'expirePayoutRatio');
            });
        },
        // 4.2满期赔付趋势排名
        queryExpiredRank: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.$request({
                                url: '/proxy/insClaim/statistics/expireTrendRanking',
                                method: 'post',
                                data: params,
                            }).then(function (res) {
                                if (!res)
                                    return;
                                if (res.errorCode)
                                    return;
                                _this.payExpiredData = res.data;
                                if (!_this.chartBarOptions) {
                                    _this.showCurrentBar();
                                }
                                return res;
                            })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        searchTrendTable: function (pageNo) {
            var _this = this;
            var pageInfo = {
                page: pageNo,
                pageSize: CLAIM_API.PAGE_SIZE,
            };
            var params = __assign({}, this.formParams(), { pageInfo: pageInfo });
            CLAIM_API.queryExpiredTrend(params).then(function (res) {
                if (!res || !res.data)
                    return;
                if (res.errorCode)
                    return;
                var pageInfo = {
                    pageNo: pageNo,
                    pageSize: CLAIM_API.PAGE_SIZE,
                    totalItemCount: res.data.totalCount,
                };
                _this.$refs.payExpiredTable.fillTableData(res.data.expireTrendList, pageInfo);
            });
        },
        // 下载
        exportFile: function () {
            var params = this.formParams();
            exportData(params);
        },
    },
    mounted: function () {
        this.setupParams();
        if (this.searchParam) {
            this.setParams(this.searchParam);
        }
        this.initIndicatorDefault();
        this.payExpiredOptions.scale = [
            {
                dataKey: 'xAxis',
                alias: '日期',
            },
            {
                dataKey: 'yAxis',
                alias: '赔付率',
                formatter: function (value) { return value + '%'; },
            },
        ];
        this.activeRankTab = this.rankTabs[0].name;
        this.onFreshPage();
    },
});
